import hackathonLogo from './Assets/hackathonLogo.jpeg';

// Importing all sponsors logos from Assets
/** Put all your Team member image inside folder `Team Images`
 * and import them like in the above and update src in TeamInfo
 * or you can provide a cloud link in src also
 */

import boy from './Assets/boy.png';


const TOP_SECTION = {
  TITLE: 'ZebraHack1.0',
  Typed_effect: [
    'a full day of fun',
    'a full day of creation',
    'a full day of innovation'
  ],
  SHORT_DESCRIPTION:
    'Join us on 16th December 2023 with over 150 Web Technologies students for a full day of creation, innovation, & fun.',
  IMG_SRC: boy,
  DISCORD_LINK: '',
  PARTICIPANT_LINK:
    'https://docs.google.com/spreadsheets/d/1u14lOhC787PPYjwNEiWVu7qbuK4J83aTjkDP32qeCn8/edit?usp=sharing',
  };

const SOCIALS = {
  whatsapp: 'https://chat.whatsapp.com/LI04iDTsPEZHfcQDVNyWJN',
  // discord: 'https://discord.com/invite/8XJSzmtWPp',
  // linkedin: 'https://www.linkedin.com/company/limbo-hacks/',
  // twitter: 'https://twitter.com/HacksLimbo',
  // devpost: 'https://limbo-hacks-12968.devpost.com/',
  email1: 'mailto:iulia.iacob@upb.ro',
  email2: 'mailto:daniela.hossu@upb.ro',
  mail: 'iulia.iacob@upb.ro, daniela.hossu@upb.ro'
};

const MIDDLE_SECTION = {
  TITLE: 'What is ZebraHack1.0?',
  LONG_DESCRIPTION:
    'ZebraHack1.0 is a full day hackathon where students in the second year at UPB will be able to create a project using everything they have learned about HTML, CSS and JavaScript.',
  LOGO: hackathonLogo
};

const FOOTER = {
  VOLUNTEERING_FORM: {
    required: true,
    src: 'https://docs.google.com/spreadsheets/d/1u14lOhC787PPYjwNEiWVu7qbuK4J83aTjkDP32qeCn8/edit?usp=sharing'
  },
  JOIN_TEAM: {
    required: false,
    src: ''
  },
  Privacy_policy: {
    required: false,
    src: ''
  },
  Terms_of_use: {
    required: false,
    src: ''
  }
};

/** SCHEDULE
 *
 * INSTRUCTIONS
 *
 * Date format : 8-11-2021, 18-11-2021 (without trailing zeros)
 */

const calenderStartingDate = {
  month: 12,
  year: 2023
};

const schedule = [
  {
    day: '16-12-2023',
    events: [
      {
        title: 'Registration',
        timings: '8:30 AM - 9:00 AM'
      },
      {
        title: 'Opening ceremony and hackaton theme reveal',
        timings: '9:00 AM - 9:30 AM'
      },
      {
        title: 'Coding session',
        timings: '09:30 AM - 15:30 PM'
      },
      {
        title: 'Final submission of the project and slides on github',
        timings: '15:30 PM - 16:00 PM'
      },
      {
        title: 'Demo in front of judges',
        timings: '16:00 PM - 20:00 PM'
      },
      {
        title: 'Awards and closing ceremony',
        timings: '20:00 PM - 21:00 PM'
      }
    ]
  }
];

/** ICON
 *
 * icons are from fontawesome visit = https://fontawesome.com
 * and just copy paste icon links and update icon in Prizeinfo
 *
 * INSTRUCTIONS
 *
 * Insert only 3 or less then 3 prizes per array in `Prizeinfo`, you can
 * create as many arrays you want all prizes will be rendered
 * in a group of 3.
 */

const Prizeinfo = [
  [
    //Array 1
    {
      icon: <i className="first fas fa-4x fa-trophy"></i>,
      type: 'overall First',
      content:
        'First Overall prize will be given to a project that outstands all other submissions'
    },
    {
      icon: <i className=" second fas fa-4x fa-medal"></i>,
      type: 'overall Second',
      content:
        'Second Overall prize will be given to the second best project of the hackathon'
    },
    {
      icon: <i className=" third fas fa-4x fa-skiing-nordic"></i>,
      type: 'Third Second',
      content:
        'Best third overall project of the hackathon will win some awesome prizes'
    }
  ],
  [
    //Array 2
    {
      icon: <i className="fab fourth fa-3x fa-wpbeginner"></i>,
      type: 'Best Solo',
      content:
        'You project will qualify for this prize if you participate alone without a team though we encourage you to participate with a team'
    },
    {
      icon: <i className="first fas fa-4x fa-trophy"></i>,
      type: ' Best Beginner',
      content: 'Your project will qualify for this category if atleast 50% '
    },
    {
      icon: <i className=" fifth fa-3x fas fa-book-open"></i>,
      type: 'Best UI/UX',
      content: 'Project with most creative designs will be UI/UX track'
    }
  ],
  [
    //Array 3
    {
      icon: <i className="fas fa-4x sixth fa-male"></i>,
      type: 'Best Web App with Qoom',
      content: 'Must use qoom in your project to win this category'
    },
    {
      icon: <i className="fas fa-user-friends seventh fa-3x "></i>,
      type: 'More prizes',
      content: 'More prizes will be revealed later'
    }
  ]
];

/** Instructions
 * Insert only 3 or less then 3 members per array in `TeamInfo`, you can
 * create as many arrays you want all team members will be rendered
 * in a group of 3.
 */

const TeamInfo = [
  [
  ]
];

const JudgesInfo = [
  []
];

/** Instructions
 * Only put 3 logos per array inside `sponsorLogos`, you can
 * create as many arrays you want all logos will be rendered
 * in a group of 3.
 */

const sponsorLogos = [
[]
];

/** Instructions
 * Follow the structure provided below to add as many as FAQ's you want
 */
const frequentlyAskedQuestions = [
  [
    [
      {
        label: 'What is ZebraHack1.0?',
        content:
          'ZebraHack1.0 is an event where teams come together to collaborate, brainstorm, and develop solutions to specific challenges within a designated time frame.'
      },
      {
        label: 'What is the purpose of ZebraHack1.0?',
        content:
          'The purpose of ZebraHack1.0 is to foster creativity, collaboration, and problem-solving skills among second year web technologies students. It aims to generate ideas and prototypes that address specific challenges or problems.'
      },
      {
        label: 'How long does ZebraHack1.0 last?',
        content:
          'The duration of ZebraHack1.0 is 6 hours from 9:00AM to 4 PM on December 16th, 2023.'
      },
    
      {
        label: 'Can I participate individually, or do I need to form a team?',
        content:
          'ZebraHack1.0 allows only team participation, a minimum of two participants and a maximum of four participants.'
      },
      {
        label: 'What are the criteria for judging the hackathon projects?',
        content:
          'The common factors that will be used for judging criteria include: technical implementation, UI / UX and presentation quality.'
      },
      {
        label: 'Can I work on an existing project during the hackathon?',
        content:
          'ZebraHack1.0 encourages participants to start their projects from scratch during the event.'
      },
    ],[
      {
        label: 'What resources will be provided during the ZebraHack1.0?',
        content:
          'ZebraHack1.0 will provide participants with basic resources, such as a workspace (EC Hollway), internet access, power outlets, and drinks.'
      },
      {
        label:
          'Can I use open-source libraries, frameworks, code snippets or CharGPT?',
        content:
          'The use of open-source libraries, frameworks, and code snippets is NOT allowed in ZebraHack1.0. You can use ONLY the official documentation or materials provided at the course (e.g. MDN)'
      },
      {
        label: 'Where will ZebraHack1.0 be held?',
        content:
          'ZebraHack1.0 will be held at the faculty of Automatic Control and Computer Science, EC Hallway'
      },
    
      {
        label: 'Can I participate in a hackathon remotely?',
        content:
          'Unfortunately, ZebraHack1.0 will not allow remote participation options. It allows teams to join physically.'
      },
      {
        label: 'Can anyone attend the ZebraHack1.0 event?',
        content:
          'Only the opening and closing sessions of ZebraHack1.0 will be open to the public, but the remaining parts will be restricted to the contestants and organisers.'
      }
    ]
  ]
];

export {
  TOP_SECTION,
  MIDDLE_SECTION,
  SOCIALS,
  FOOTER,
  Prizeinfo,
  sponsorLogos,
  TeamInfo,
  JudgesInfo,
  frequentlyAskedQuestions,
  schedule,
  calenderStartingDate
};
